import React from 'react';

import LineStrokeColorTabContent from 'editor/src/component/DesktopSidebar/TabContents/LineStrokeColorTabContent';

function LineStrokeColorActionBar() {
  return <LineStrokeColorTabContent />;
}

export default React.memo(LineStrokeColorActionBar);
